import MarkdownContent from '../common/MarkdownContent';
import type { NoticeBlock } from '../../api/staticPageBlocks';

const NoticeBlockView = ({ block }: { block: NoticeBlock }) => (
  <div className={`notification is-${block.style} block-notice`}>
    <MarkdownContent content={block.markdown} />
  </div>
);

export default NoticeBlockView;
